import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const typeSafe = defineConnector({
  identifier: "typeSafe",
  name: "TypeSafe",
  tagLine: "Structured AI decisions with calibrated confidence",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.typesafe\\.ai/v1/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [API keys](https://console.typesafe.ai/keys) in the TypeSafe console and create an API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.typesafe.ai/v1/models",
  },
  usageHint: () =>
    "Send state, model, and typed questions to POST https://api.typesafe.ai/v1/systemone. Use GET https://api.typesafe.ai/v1/models to list available models. Pass a placeholder bearer token; the proxy injects your API key.",
});
